import useTranslation from "@babackapp/translations/use-translation";
import { Badge } from "@babackapp/ui/components/badge";
import { EditIcon } from "lucide-react";
import { useEffect, useRef, useState } from "react";
type Props = {
  onChangeReason: (reason: string) => void;
  reason: string;
};
const TextAreaWithSuggestions = ({ onChangeReason, reason }: Props) => {
  const [open, setOpen] = useState(true);
  const containerRef = useRef<HTMLDivElement>(null);
  const t = useTranslation();
  const suggestions = {
    addedByMistake: { text: "Add to return by mistake", icon: "⚡" },
    nonCompliant: { text: "Non compliant", icon: "💥" },
    damaged: {
      text: "Damaged ",
      icon: "🚑",
    },
    other: {
      text: "Other",
      icon: "🚀",
    },
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={containerRef} className="w-full p-2">
      {open || !reason ? (
        <textarea
          className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-gray-500 resize-none placeholder:text-gray-300"
          placeholder="Add your reject reason"
          value={reason}
          onChange={(e) => onChangeReason(e.target.value)}
          rows={4}
        />
      ) : (
        <div
          className="p-3 bg-gray-50 flex items-center justify-between w-full cursor-pointer"
          onClick={() => setOpen(true)}
        >
          <p className="text-gray-400 w-[60vh] truncate">{reason}</p>
          <EditIcon className="size-4" />
        </div>
      )}

      {!reason && (
        <div className="mb-1">
          <span className="text-muted-foreground text-sm mt-1 mb-2">
            {t("misc.suggestions")}
          </span>
          <div className="flex space-x-2 mt-2">
            {Object.values(suggestions).map((suggestion) => (
              <Badge
                key={suggestion.text}
                variant="outline"
                className="flex items-center text-primary border-primary rounded-xl hover:bg-primary hover:text-white cursor-pointer"
                onClick={() => onChangeReason(suggestion.text)}
              >
                {suggestion.text} {suggestion.icon}
              </Badge>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TextAreaWithSuggestions;
